/** @format */

import {styled} from '@mui/material/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  IconButton,
  Chip,
  Typography,
} from '@mui/material';
import {Checklist} from '@mui/icons-material';

export const StyledDialog = styled(Dialog)(({theme}) => ({
  '& .MuiDialog-paper': {
    borderRadius: theme.spacing(2),
    width: '800px',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 3),
  backgroundColor: '#D0E7FB',
  borderBottom: '1px solid #666666',
  color: theme.palette.text.secondary,
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: 400,
  borderRadius: theme.spacing(2, 2, 0, 0),
}));

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  color: theme.palette.figma_primary?.dark,
}));

export const StyledDialogContent = styled(DialogContent)(({theme}) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
}));

export const StyledDialogActions = styled(DialogActions)(({theme}) => ({
  justifyContent: 'flex-start',
  marginTop: theme.spacing(8),
  padding: theme.spacing(0),
}));

export const SearchContainer = styled(Box)(({theme}) => ({
  color: 'black',
  marginTop: theme.spacing(4),
  '& .MuiTextField-root': {
    '& .MuiOutlinedInput-root': {
      color: '#696A6E',
      '& fieldset': {
        borderColor: '#B9BABF',
      },
      '& .MuiInputBase-input': {
        padding: 0,
        '&::placeholder': {
          color: '#696A6E',
          opacity: 1,
        },
      },
      '& .MuiInputAdornment-root': {
        color: '#696A6E',
      },
    },
  },
}));

export const ButtonsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(4),
}));

export const StyledButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isSubmit',
})<{isSubmit?: boolean}>(({theme, isSubmit}) => ({
  backgroundColor: isSubmit ? theme.palette.figma_emerald?.main : '#E2E3E9',
  padding: theme.spacing(2, 4),
  color: isSubmit ? '#F9FCFA' : theme.palette.figma_gray_dark_5?.main,
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: 400,
  '&:hover': {
    background: isSubmit ? '#5ab983' : theme.palette.figma_surface?.light,
  },
  '&:active': {
    background: isSubmit ? '#86caa0' : theme.palette.figma_primary?.light,
  },
}));

export const OpenModalContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  color: theme.palette.figma_gray_light_4?.main,
  alignItems: 'center',
  fontSize: '14px',
  lineHeight: '16px',
}));

export const StyledOpenButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.figma_gray_dark_4?.main,
  color: theme.palette.figma_gray_light_4?.main,
  padding: theme.spacing(2, 4),
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: 400,
  '&:hover': {
    background: '#696A6E',
  },
  '&:active': {
    background: theme.palette.figma_primary?.light,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.figma_gray_dark_4?.main,
    color: '#696A6E',
  },
}));

export const TableContainer = styled(Box)(({theme}) => ({
  flex: 1,
  minHeight: 0,
  marginTop: theme.spacing(4),
}));

export const ChecklistIcon = styled(Checklist)(({theme}) => ({
  marginRight: theme.spacing(2),
}));

export const SelectedChipsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
}));

export const StyledChip = styled(Chip)(({theme}) => ({
  backgroundColor: '#214D72',
  color: theme.palette.text.primary,
  fontSize: '12px',
  height: '24px',
}));

export const RemainingCountText = styled(Typography)(({theme}) => ({
  color: theme.palette.text.primary,
  fontSize: '12px',
  marginTop: theme.spacing(1),
}));
